(() => {
  'use strict';
  const boot = () => {
    document.querySelectorAll('[data-yb-maxk14]').forEach(root => {
      if (root.dataset.enhanced) return;
      const productForm = root.querySelector('product-form');
      const form = productForm?.querySelector('form');
      const quantity = form?.querySelector('[data-quantity]');
      const submit = form?.querySelector('[type="submit"]');
      const card = root.querySelector('#ybmk-purchase-card');
      const mount = root.querySelector('[data-inline-purchase-mount]');
      if (!form || !quantity || !submit || !card || !mount) return;
      root.dataset.enhanced = 'true';
      const title = root.querySelector('.ybmk-hero h1');
      if (/^zh/i.test(document.documentElement.lang) && title?.textContent.includes('，')) {
        const parts = title.textContent.split('，');
        title.replaceChildren(...parts.map((text,index) => {const span=document.createElement('span');span.style.display='inline-block';span.textContent=text+(index<parts.length-1?'，':'');return span;}));
      }

      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      const minimum = Math.max(1,Number(quantity.min)||1);
      const increment = Math.max(1,Number(quantity.step)||1);
      const maximum = quantity.max ? Math.max(minimum,Number(quantity.max)) : Infinity;
      const unitPrice = Number(root.dataset.unitPrice)||0;
      const currency = root.dataset.currency||'USD';
      const formatter = new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency,currencyDisplay:'narrowSymbol'});
      let quantityValue = minimum;
      let pendingVariant = null;
      let busy = false;
      const minus = root.querySelector('[data-quantity-decrease]');
      const plus = root.querySelector('[data-quantity-increase]');
      const payment = root.querySelector('[data-payment-wrapper]');
      const unavailable = root.dataset.available !== 'true';
      const formatPrice = cents => formatter.format(cents/100)+' '+currency;
      const setQuantity = next => {
        const clamped = Math.max(minimum,Math.min(maximum,Number.isFinite(next)?Math.floor(next):minimum));
        quantityValue = minimum+Math.floor((clamped-minimum)/increment)*increment;
        quantity.value = String(quantityValue);
        minus.disabled = busy || unavailable || quantityValue<=minimum;
        plus.disabled = busy || unavailable || quantityValue+increment>maximum;
        root.querySelector('[data-total]').textContent = formatPrice(unitPrice*quantityValue);
        root.querySelector('[data-mobile-total]').textContent = formatPrice(unitPrice*quantityValue);
      };
      const synchronizeBusy = () => {
        busy = Boolean(submit.classList.contains('loading') || submit.getAttribute('aria-disabled')==='true' || productForm.cartRecoveryPending);
        root.dataset.cartBusy = String(busy);
        quantity.disabled = busy || unavailable;
        if(payment)payment.inert=busy;
        setQuantity(quantityValue);
      };
      minus.addEventListener('click',()=>{if(!busy)setQuantity(quantityValue-increment);});
      plus.addEventListener('click',()=>{if(!busy)setQuantity(quantityValue+increment);});
      quantity.addEventListener('change',()=>{if(!busy)setQuantity(Number(quantity.value));});
      quantity.addEventListener('blur',()=>{if(!busy)setQuantity(Number(quantity.value));});
      const observer = new MutationObserver(synchronizeBusy);
      observer.observe(submit,{attributes:true,attributeFilter:['class','aria-disabled','disabled']});
      form.addEventListener('submit',event=>{
        if(busy||unavailable||submit.disabled||submit.getAttribute('aria-disabled')==='true'||productForm.cartRecoveryPending){event.preventDefault();event.stopImmediatePropagation();return;}
        setQuantity(Number(quantity.value));
        pendingVariant=String(form.querySelector('[name="id"]').value);
      },true);
      setQuantity(Number(quantity.value));
      synchronizeBusy();
      const updateHeaderOffset = () => {
        const headers=Array.from(document.querySelectorAll('sticky-header,.section-header,[data-section-type="header"]'));
        const offset=headers.reduce((result,node)=>{const style=getComputedStyle(node);const rect=node.getBoundingClientRect();return(style.position==='sticky'||style.position==='fixed')&&rect.top<=1&&rect.bottom>0?Math.max(result,rect.bottom):result;},0);
        root.style.setProperty('--ybmk-site-header-offset',Math.round(offset)+'px');
      };
      let scrollFrame=0;
      window.addEventListener('scroll',()=>{if(scrollFrame)return;scrollFrame=requestAnimationFrame(()=>{scrollFrame=0;updateHeaderOffset();});},{passive:true});
      window.addEventListener('resize',updateHeaderOffset);updateHeaderOffset();
      for(const rail of root.querySelectorAll('[data-rail]')){
        const track=rail.querySelector('.ybmk-rail-track');
        const previous=rail.querySelector('[data-rail-prev]');
        const next=rail.querySelector('[data-rail-next]');
        const cards=Array.from(track.children);let frame=0;
        const update=()=>{
          const maximumScroll=Math.max(0,track.scrollWidth-track.clientWidth);
          previous.disabled=track.scrollLeft<=2;next.disabled=track.scrollLeft>=maximumScroll-2;
          const closest=cards.reduce((best,node,index)=>{const distance=Math.abs(node.offsetLeft-cards[0].offsetLeft-track.scrollLeft);return distance<best.distance?{index,distance}:best;},{index:0,distance:Infinity});
          rail.querySelector('[data-rail-progress]').textContent=String(maximumScroll<=2?1:next.disabled?cards.length:closest.index+1);
          rail.dataset.atStart=String(previous.disabled);rail.dataset.atEnd=String(next.disabled);
        };
        const move=direction=>{const distance=cards.length>1?cards[1].offsetLeft-cards[0].offsetLeft:track.clientWidth;track.scrollBy({left:direction*distance,behavior:reduce.matches?'auto':'smooth'});};
        previous.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));
        track.addEventListener('keydown',event=>{if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;event.preventDefault();if(event.key==='ArrowLeft')move(-1);else if(event.key==='ArrowRight')move(1);else track.scrollTo({left:event.key==='Home'?0:track.scrollWidth,behavior:reduce.matches?'auto':'smooth'});});
        track.addEventListener('scroll',()=>{if(frame)return;frame=requestAnimationFrame(()=>{frame=0;update();});},{passive:true});window.addEventListener('resize',update);update();
      }
      const triggers=Array.from(root.querySelectorAll('[data-open-purchase]'));
      let dialog=null;
      let returnTrigger=null;
      let scrollLock=null;
      const unlock=()=>{
        if(!scrollLock)return;
        document.body.style.overflow=scrollLock.overflow;
        if(!scrollLock.hadClass&&!document.querySelector('cart-drawer.active,cart-notification.active'))document.body.classList.remove('overflow-hidden');
        scrollLock=null;triggers.forEach(t=>t.setAttribute('aria-expanded','false'));
      };
      const restoreCard=()=>{mount.appendChild(card);mount.style.minHeight='';};
      const close=(restoreFocus=true)=>{
        if(!dialog?.open)return;
        dialog.close();unlock();restoreCard();
        if(restoreFocus&&returnTrigger?.isConnected)returnTrigger.focus({preventScroll:true});
      };
      const open=trigger=>{
        if(!dialog){mount.scrollIntoView({behavior:reduce.matches?'auto':'smooth',block:'center'});quantity.focus({preventScroll:true});return;}
        if(dialog.open)return;
        returnTrigger=trigger||triggers[0];
        mount.style.minHeight=card.getBoundingClientRect().height+'px';dialog.appendChild(card);
        scrollLock={overflow:document.body.style.overflow,hadClass:document.body.classList.contains('overflow-hidden')};
        document.body.style.overflow='hidden';document.body.classList.add('overflow-hidden');
        dialog.showModal();returnTrigger?.setAttribute('aria-expanded','true');
        requestAnimationFrame(()=>{if(!quantity.disabled)quantity.focus({preventScroll:true});else dialog.querySelector('[data-close-purchase]').focus({preventScroll:true});});
      };
      if(typeof HTMLDialogElement!=='undefined'&&HTMLDialogElement.prototype.showModal){
        dialog=document.createElement('dialog');dialog.className='ybmk-purchase-dialog';dialog.id='ybmk-purchase-dialog';dialog.tabIndex=-1;dialog.setAttribute('aria-labelledby','ybmk-purchase-title');
        const closeButton=document.createElement('button');closeButton.type='button';closeButton.className='ybmk-dialog-close';closeButton.dataset.closePurchase='';closeButton.setAttribute('aria-label',root.dataset.purchaseCloseLabel);closeButton.textContent='×';dialog.append(closeButton);root.append(dialog);
        triggers.forEach(t=>{t.setAttribute('aria-haspopup','dialog');t.setAttribute('aria-controls',dialog.id);t.setAttribute('aria-expanded','false');});
        closeButton.addEventListener('click',()=>close());
        dialog.addEventListener('cancel',event=>{event.preventDefault();close();});
        dialog.addEventListener('close',()=>{unlock();if(card.parentNode===dialog)restoreCard();});
        dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const bounds=dialog.getBoundingClientRect();if(event.clientX<bounds.left||event.clientX>bounds.right||event.clientY<bounds.top||event.clientY>bounds.bottom)close();});
      }
      root.addEventListener('click',event=>{
        if(!(event.target instanceof Element))return;
        const trigger=event.target.closest('[data-open-purchase]');
        if(!trigger||!root.contains(trigger)||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
        event.preventDefault();event.stopPropagation();open(trigger);
      },true);
      root.querySelectorAll('a[href^="#"]').forEach(link=>link.addEventListener('click',event=>{
        if(link.hasAttribute('data-open-purchase')||event.defaultPrevented)return;
        const target=root.querySelector(link.getAttribute('href'));if(!target)return;event.preventDefault();target.scrollIntoView({behavior:reduce.matches?'auto':'smooth',block:'start'});
      }));
      let unsubscribe=null;
      if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined'){
        unsubscribe=subscribe(PUB_SUB_EVENTS.cartUpdate,event=>{
          const variant=String(event?.productVariantId);
          if(event?.source!=='product-form'||!pendingVariant||variant!==pendingVariant||!event.cartData||event.cartData.status||!root.isConnected)return;
          pendingVariant=null;
          if(dialog?.open){close(false);if(returnTrigger?.isConnected)productForm.cart?.setActiveElement?.(returnTrigger);}
        });
      }
      document.addEventListener('shopify:section:unload',event=>{
        if(event.target instanceof Element&&event.target.contains(root)){close(false);observer.disconnect();unsubscribe?.();}
      });
      if(location.hash==='#ybmk-buy')open(triggers[0]);
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();
